import { createBrowserRouter } from "react-router-dom";
import { AuthProvider } from "../AuthContext";
import Create from "../Create";
import Layout from "../Layout";
import Profile from "../Profile";
import ProtectedRoute from "../ProtectedRoute";
import SignIn from "../SignIn";

const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <Layout />
      </AuthProvider>
    ),
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <Create />
          </ProtectedRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      { path: "/signin", element: <SignIn /> },
    ],
  },
]);

export default router;
